import { render, staticRenderFns } from "./cabinet-commercial-notice-card-unpublish-button.vue?vue&type=template&id=1d465748&"
import script from "./cabinet-commercial-notice-card-unpublish-button.vue?vue&type=script&lang=js&"
export * from "./cabinet-commercial-notice-card-unpublish-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d465748')) {
      api.createRecord('1d465748', component.options)
    } else {
      api.reload('1d465748', component.options)
    }
    module.hot.accept("./cabinet-commercial-notice-card-unpublish-button.vue?vue&type=template&id=1d465748&", function () {
      api.rerender('1d465748', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/commercial/cards/partials/cabinet-commercial-notice-card-unpublish-button.vue"
export default component.exports